import { cn } from '@xver/utils/classname';

interface RowActionButtonProps {
    /** Visible verb, e.g. "Detach". */
    label: string;
    /** Object read after the verb by screen readers only, so repeated buttons stay unique. */
    name: string;
    /**
     * Id of the visible text saying why the action is unavailable. The button then stays focusable
     * with `aria-disabled` and that text as its description, so focus never drops when a status
     * change blocks it. The caller renders the text (see VolumeRowActions).
     */
    blockedReasonId?: string;
    danger?: boolean;
    onClick: () => void;
}

export default function RowActionButton({
    label,
    name,
    blockedReasonId,
    danger,
    onClick,
}: RowActionButtonProps) {
    const blocked = !!blockedReasonId;

    return (
        <button
            type="button"
            aria-disabled={blocked || undefined}
            aria-describedby={blockedReasonId}
            onClick={(event) => {
                event.stopPropagation();
                if (!blocked) onClick();
            }}
            className={cn(
                'min-h-8 px-2.5 rounded-md border-[0.5px] border-line bg-surface-2 text-sm font-medium transition-colors',
                danger ? 'text-red-400 light:text-red-700' : 'text-fg',
                blocked ? 'opacity-50 cursor-not-allowed' : 'hover:bg-surface-3'
            )}
        >
            {label}
            <span className="sr-only"> {name}</span>
        </button>
    );
}
